import { TYPE_COLLECTION } from './input-types';

export const id = 'allocationStatus';
export const apiKey = 'AllocationStatus';
export const type = TYPE_COLLECTION;

export const allocationStatus = {
  id,
  apiKey,
  type,
};
